import { render, staticRenderFns } from "./editLayout.vue?vue&type=template&id=05c36d62&scoped=true"
import script from "./editLayout.vue?vue&type=script&lang=js"
export * from "./editLayout.vue?vue&type=script&lang=js"
import style0 from "./editLayout.vue?vue&type=style&index=0&id=05c36d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c36d62",
  null
  
)

export default component.exports